import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { withNamespaces } from 'react-i18next';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';

import AppContainer from '../common/AppContainer';
import Breadcrumb from '../common/Breadcrumb';
import FaqList from './FaqList';
import on from '../../common/awaitHandler';

export class DefaultPage extends Component {
  static propTypes = {
    faq: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  async componentWillMount(){
    // TODO: Get tenant from map
 
    if(this.props.common && isEmpty(this.props.common.tenant)){
      const [error, resp] = await on(this.props.commonActions.requestGetTenant({tenant: 'Illinois'}));
      if(!error) {
        await on(this.props.commonActions.requestGetAfqs({ tenantId: resp.data.id}));
      }
    }
  }

  render() {
   
    const { common, t } = this.props;

    const breadcrumbLinks = [
      {
        name: t('breadcrumb.home_link'),
        url: '/'
      },
      {
        name: t('breadcrumb.faq_link'),
        url: '/faq'
      }
    ];

    return (
      <div className="faq-default-page">
        <AppContainer>
          <Breadcrumb links={breadcrumbLinks} />
          <FaqList common={common} />
        </AppContainer>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    faq: state.faq,
    common: state.common
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({...commonActions}, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces(['faq'])(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/faq/DefaultPage.js